import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="customer-information-modal"
export default class extends Controller {
  static values = {
    show: { type: Boolean, default: false }
  }

  static targets = [ "modal" ]

  connect() {
      this.open()
  }

  open() {
    if(this.hasModalTarget){
      const modal = new bootstrap.Modal(this.modalTarget)
      modal.show()
    }
  }

  close() {
    if(this.hasModalTarget){
      const modal = new bootstrap.Modal(this.modalTarget)
      if(modal){
        modal.hide()
      }
    }
  }
}
